import { colors } from 'src/styles/theme';

const ModalStyle = {
  bgcolor: 'background.paper',
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  left: '50%',
  maxHeight: '90%',
  overflow: 'auto',
  p: 4,
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: {
    lg: '50%',
    md: '65%',
    sm: '80%',
    xs: '95%',
  },
};

export default ModalStyle;
